/**
 * Implementation of MainStatus component to show the overall status of monitors
 *
 * @author - Harsh Tomar
 */

// Dependencies
import React from "react";
import { IoAlertCircleSharp } from "react-icons/io5";
import { Else, If, Then, When } from "react-if";
import { MonitorsResponse } from "../api/responses";

type Props = {
  monitorsLoading: boolean;
  monitors: MonitorsResponse[];
};

export default function MainSatus(props: Props) {
  const activeMonitors = props.monitors?.filter(monitor => monitor.status === "ACTIVE");
  const pausedMonitors = props.monitors?.filter(monitor => monitor.status === "PAUSED");
  const expiringMonitors = props.monitors?.filter(monitor => monitor.status === "EXPIRING_SOON");
  const expired = props.monitors?.filter(monitor => monitor.status === "EXPIRED");

  if (props.monitorsLoading) {
    return (
      <div className="bg-gray-300 rounded-md w-[33%] shadow-px-5 py-3 mb-5"></div>
    );
  }

  const shouldShowCaution = !!expired.length || !!expiringMonitors.length || false

  if(shouldShowCaution) {

    const borderColor = expired.length ? 'border-red-400' :  'border-orange-400'
    const iconColor = expired.length ? 'text-red-400' :  'text-orange-400'
    const textColor = expired.length ? 'text-red-400' :  'text-orange-400'

    return (
      <div className={`bg-white rounded-xl shadow px-5 py-3 mb-5 ${borderColor} border flex`}>
        <span className="relative">
          {/* <span className="animate-ping absolute inline-flex h-4 w-4 rounded-full bg-orange-600 opacity-75"></span> */}

          <IoAlertCircleSharp className={`${iconColor} mt-[2px]`} size={24}/>
          {/* <span className="relative inline-flex rounded-full h-4 w-4 bg-orange-600"></span> */}
        </span>
        <p className={`${textColor} text-lg font-bold`}>
        <When condition={expired.length === 1}>
          &nbsp;&nbsp;{expired[0]?.url} SSL is expired&nbsp;&nbsp;
        </When> 
        <When condition={expired.length > 1}>  
          &nbsp;&nbsp;{expired.length} SSL certificates has expired&nbsp;&nbsp;
        </When>
        </p>
        <p className={`${iconColor} text-lg font-bold`}>
        <When condition={expiringMonitors.length === 1}>
          &nbsp;&nbsp;{expiringMonitors[0]?.url} SSL is expiring soon&nbsp;&nbsp;
        </When>
        <When condition={expiringMonitors.length > 1}>
          &nbsp;&nbsp;{expiringMonitors.length} SSL certificates are expiring soon&nbsp;&nbsp;
        </When>
        </p>
      </div>
    )
  }

  return (
    <div className="bg-white rounded-xl shadow px-5 py-3 mb-5 border-green-400 border flex">
      <span className="flex h-4 w-4 relative mt-1.5">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-600 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-4 w-4 bg-green-600"></span>
      </span>
      <If condition={pausedMonitors.length === 0}>
        <Then>
          <p className="text-green-600 text-lg font-bold">
            &nbsp;&nbsp;All monitors are Up&nbsp;&nbsp;
          </p>
        </Then>
        <Else>
          <p className="text-green-600 text-lg font-bold">
            &nbsp;&nbsp;{activeMonitors.length} monitors are Up. {pausedMonitors.length} are paused&nbsp;&nbsp;
          </p>
        </Else>
      </If>
    </div>
  );
}
